export default "__VITE_ASSET__T9mT4OxJ__"